<div (click)="showMedia()"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)"
     [class.dragover]="isDragging" class="flex items-center justify-center">
    <div *ngIf="mediaLib.uploadingProcess && dragFile" class="module rounded-md transition-all duration-300 aspect-square relative h-32 bg-bg_primary  overflow-hidden border border-dashed bg-cover bg-center border-gray-500 block app-custom-modal-action text-center h-50 w-40">
        <div class="absolute top-0 left-0 w-full h-full bg-bg_primary bg-opacity-50 flex items-center justify-center">
            <div class="flex flex-col items-center space-y-2">
                <!-- Smaller Horizontal Progress Bar with Dynamic Color -->
                <div class="relative w-32 h-1 bg-gray-300 rounded-full overflow-hidden">
                    <!-- Animated progress bar with dynamic color based on progress -->
                    <div
                            class="absolute top-0 left-0 h-full"
                            [ngClass]="{
                                                                'bg-red-500': mediaLib.progressVideoUpload <= 30,
                                                                'bg-yellow-500': mediaLib.progressVideoUpload > 30 && mediaLib.progressVideoUpload <= 70,
                                                                'bg-green': mediaLib.progressVideoUpload > 70
                                                            }"
                            [style.width]="mediaLib.progressVideoUpload + '%'"
                            style="transition: width 0.5s ease-out;">
                    </div>
                </div>

                <!-- Progress Percentage -->
                <span class="text-normal text-sm font-semibold">{{ mediaLib.progressVideoUpload | number: '1.0-0' }}%</span>
            </div>
        </div>
    </div>
    <ng-content *ngIf="!mediaLib.uploadingProcess || !dragFile" ></ng-content>
</div>